// extracted by mini-css-extract-plugin
export default {"slider-arrow":"SliderArrow_slider-arrow__24QCu","slider-arrow--prev":"SliderArrow_slider-arrow--prev__2CiEp","slider-arrow--next":"SliderArrow_slider-arrow--next__2Tto9"};